module.exports = __webpack_public_path__ + "494cd07c/img/note-edit-icon.acae1669.svg";